module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "lahaina-fire-background.e21f19be.jpg";